import { render } from "./Header.vue?vue&type=template&id=31c4b7fa"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=31c4b7fa&lang=scss"
script.render = render

export default script